import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Col, Row, } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/ContextData'
import AlertMessage from '../../components/modals/AlertMessage'
import DealerConnectModal from '../../components/modals/DealerConnectModal'
import ShareModal from '../../components/modals/ShareModal'
import DemoModal from '../../components/modals/DemoModal'
import Paginations from '../../components/Pagenation'

const MoreProducts = ({ title, heading_css, breadcrum, data, page, pages, setPage }) => {
    const navigate = useNavigate();
    // const [pages, setPage]= useState(1);

    const [showShare, setShowShare] = useState(false);
    const [shareUrl, setShareUrl] = useState('');
    const [title1, setTitle] = useState('');
    const hostname = document.location.origin;
    const [showToast, setShowToast] = useState(false);
    const [reqType, setReqType] = useState("");
    const [delaerShow, setDelaerShow] = useState(false);
    const [demoToast, setDemoToast] = useState(false);

    const { wished, setWished, removeWished, setRemoveWished, cart, setCart, removeCart, setRemoveCart, demo, dealerId } = useAuth()

    // ---------------------------Wished Items------------------------
    const localWished = JSON.parse(localStorage.getItem("wished"))
    useEffect(() => {
        if (localWished && wished.length === 0) {
            if (removeWished === 0) {
                localStorage.removeItem("wished")
            } else {
                setWished(...wished, localWished)
            }
        }
        if (wished.length !== 0) {
            localStorage.setItem("wished", JSON.stringify(wished))
        }

    }, [wished, setWished, localWished, removeWished,])

    // ---------------------------Cart Items------------------------
    const localCart = JSON.parse(localStorage.getItem("cart"))
    useEffect(() => {
        if (localCart && cart.length === 0) {
            if (removeCart === 0) {
                localStorage.removeItem("cart")
            } else {
                setCart(...cart, localCart)
            }
        }
        if (cart.length !== 0) {
            localStorage.setItem("cart", JSON.stringify(cart))
        }

    }, [cart, setCart, localCart, removeCart,])
    const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)
    const myRef = useRef(null)

    const onPageChanged = useCallback(
        (event, page) => {
            event.preventDefault();
            setPage(page);
            scrollToRef(myRef)
        },
        [setPage]
    );
    return (
        <React.Fragment>
            <ShareModal
                show={showShare}
                setShowShare={() => setShowShare(false)}
                url={shareUrl}
                title={title1}
            />
            <DealerConnectModal
                show={delaerShow}
                setShow={setDelaerShow}
            />
            <AlertMessage
                show={showToast}
                setShow={() => setShowToast(false)}
                reqType={reqType}
            />
            <DemoModal
                show={demoToast}
                setShow={setDemoToast}
            />

            <div className="wm" ref={myRef}>
                <h1 className={heading_css ? heading_css : "text-center"}>{title} {breadcrum && '-'} {breadcrum}</h1>
                <Row className="mx-0 mb-3 cp">
                    <Col >
                        Filter By Qty <input type="text" className="filterSort" />
                    </Col>
                    <Col className="text-end">
                        Sort By <select className="filterSort">
                            <option value="">Popularity</option>
                            <option value="">Price--Low to High</option>
                            <option value="">Price--High to Low</option>
                            <option value="">Newest First</option>
                        </select>
                    </Col>
                </Row>
                <Row className="mx-0">
                    {data.length > 0 ? data.map((item, index) =>
                        <Col lg={3} md={4} sm={6} key={index} className="mb-3">
                            <div >
                                <Link to={'/productdetails/' + (item.title && item.title.replace(/[\s,-;]+/g, "-").toLowerCase()) + "/" + item.itemNo + (dealerId && "?dealerId=" + dealerId)}>
                                    <img src={process.env.REACT_APP_S3URL + item.masterimg} alt={item.title} className="w-100 mp_img_mh" />
                                </Link>
                                <Row className="mx-0">
                                    <Col xxl={9} xs={8} className="px-0 cp">
                                        <Link to={'/productdetails/' + (item.title && item.title.replace(/[\s,-;]+/g, "-").toLowerCase()) + "/" + item.itemNo}>
                                            <h3 className="mp_text_length mb-0 fs-6">
                                                {item.title}
                                            </h3>
                                            {item.price && <h6 className="cpm">&#8377; {item.price}/{item.unit} </h6>}
                                        </Link>
                                    </Col>
                                    <Col xxl={3} xs={4} className="text-end px-0">
                                        <img src="/assets/icons/share.png" alt="bg" className="mouse mpswb mt-2" onClick={() => { setShowShare(true); setTitle(item.title); setShareUrl(hostname + '/productdetails/' + (item.title && item.title.replace(/[\s,-;]+/g, "-").toLowerCase()) + "/" + item.itemNo) }} />
                                        <img src={
                                            wished.find(obj => obj.itemNo === item.itemNo)
                                                ? "/assets/icons/wished.png" : "/assets/icons/wish.svg"}
                                            alt="wish"
                                            className={`mouse mpswb mx-2 mt-2 `}
                                            onClick={() => {
                                                if (demo) {
                                                    setDemoToast(true)
                                                }
                                                else if (!dealerId) {
                                                    setDelaerShow(true)
                                                }
                                                else if (wished.find(obj => obj.itemNo === item.itemNo)) {
                                                    if (wished.length === 1) {
                                                        setRemoveWished(0)
                                                        setReqType("removeWished")
                                                    }
                                                    const x = wished.indexOf(wished.find(obj => obj.itemNo === item.itemNo))
                                                    wished.splice(x, 1)
                                                    setWished([...wished])
                                                    setReqType("removeWished")
                                                }
                                                else if (cart.find(obj => obj.itemNo === item.itemNo)) {
                                                    if (cart.length === 1) {
                                                        setRemoveCart(0)
                                                        setWished([...wished, item])
                                                        setReqType("moveWished")
                                                        setShowToast(true)
                                                    }
                                                    const x = cart.indexOf(cart.find(obj => obj.itemNo === item.itemNo))
                                                    cart.splice(x, 1)
                                                    setCart([...cart])
                                                    setWished([...wished, item])
                                                    setReqType("moveWished")
                                                    setShowToast(true)
                                                }
                                                else {
                                                    setWished([...wished, item])
                                                    setReqType("addWished")
                                                    setShowToast(true)
                                                }
                                            }} />
                                        <img
                                            src={cart.find(obj => obj.itemNo === item.itemNo) ? "/assets/icons/bagGreen.svg" : "/assets/icons/bag.svg"}
                                            alt="cart"
                                            className="mouse mpswb mt-2"
                                            onClick={() => {
                                                if (demo) {
                                                    setDemoToast(true)
                                                }
                                                else if (!dealerId) {
                                                    setDelaerShow(true)
                                                }
                                                else if (cart.find(obj => obj.itemNo === item.itemNo)) {
                                                    navigate("/checkout/cart")
                                                }
                                                else if (wished.find(obj => obj.itemNo === item.itemNo)) {
                                                    if (wished.length === 1) {
                                                        setRemoveWished(0)
                                                        setCart([...cart, item])
                                                        setReqType("moveCart")
                                                        setShowToast(true)
                                                    }
                                                    const x = wished.indexOf(wished.find(obj => obj.itemNo === item.itemNo))
                                                    wished.splice(x, 1)
                                                    setWished([...wished])
                                                    setCart([...cart, item])
                                                    setReqType("moveCart")
                                                    setShowToast(true)
                                                }
                                                else {
                                                    setCart([...cart, item])
                                                    setReqType("addCart")
                                                    setShowToast(true)
                                                }
                                            }} />
                                    </Col>
                                </Row>
                            </div>
                        </Col>

                    ) : <h3 className="text-center">
                        There are no product
                    </h3>}
                </Row>
                {pages > 1 &&
                    <Paginations
                        pageNeighbours={3}
                        onPageChanged={onPageChanged}
                        currentPage={page}
                        totalPages={pages}
                    />
                }
            </div>
        </React.Fragment>
    )
}

export default MoreProducts
